import React from 'react'

const Spinner = () => {
  return (
    <div class="loaderdiv">
      <img
                            width="10%"
                            // height={45}
                            className=" pt-0"
                            style={{ display: "inline" }}
                            src="/assets/images/seal/tathmeer-animated.gif"
                            alt="tathmeer-seal"
                            aria-hidden="true"
                        />
    </div>
  )
}

export default Spinner;
